import { render } from "./Repos.vue?vue&type=template&id=4360b30d&ts=true"
import script from "./Repos.vue?vue&type=script&lang=ts"
export * from "./Repos.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__